import { INavbarItem } from "src/Interfaces/NavbarInterfaces";
import Navbar from "./Navbar/Navbar";
import UserInfoBox from "./UserInfoBox";

interface IProps {
  navbarItems: Array<INavbarItem> | null;
}

const Header = ({ navbarItems }: IProps) => {
  return (
    <div className="flex flex-col justify-start items-start mb-5 relative">
      <Navbar navbarItems={navbarItems} />
      <div className="max-w-min absolute left-0 top-10">
        <UserInfoBox />
      </div>
    </div>
  );
};

export default Header;
